import { useQuery } from '@apollo/client/react/hooks'
import { Box, Text } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { AtsJobPostingPremiumPortalsDocument } from 'generated/resources/graphql'
import { range } from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { JobPostingLayout } from 'modules/ats/components/job_postings/JobPostingLayout'

import { useJobDetailsContext } from '../JobsPage/JobDetails'
import { PremiumBundleCard } from './PremiumBundleCard'
import { PremiumBundleCardSkeleton } from './PremiumBundleCard/PremiumBundleCardSkeleton'
import { premiumOfferCardsGridStyle } from './index.vanilla.css'

export const JobPostingPremiumPortals = () => {
  const { job } = useJobDetailsContext()
  const { access } = useCurrentSession()
  const legalEntityId = job.attributes.legal_entity_id || -1
  const { data, loading } = useQuery(AtsJobPostingPremiumPortalsDocument, {
    variables: { accessId: access.id, atsJobPostingId: job.id, legalEntityId },
    skip: !job.id || !legalEntityId,
  })

  // TODO: handle if no data
  const currency = data?.companies.legalEntity?.currency
  const premiumBundles = data?.integrationsJoin.premiumBundlesConnection.nodes || []

  return (
    <JobPostingLayout job={job}>
      <Box gap="s20">
        <SectionHeader title={i18n.t('ats.job_details.premium_portals.title')} description={''} />
        <Box gap="s20">
          {/* premium bundles */}
          <Box gap="s16">
            <Text.Normal
              weight="semibold"
              size="300"
              color="grey1000"
              title={i18n.t('ats.job_details.premium_portals.bundles.title')}
            >
              {i18n.t('ats.job_details.premium_portals.bundles.title')}
            </Text.Normal>

            <Box gap="s16" className={premiumOfferCardsGridStyle}>
              {loading
                ? range(3).map((index) => (
                    <PremiumBundleCardSkeleton key={`bundle-card-skeleton-${index}`} />
                  ))
                : premiumBundles.map((bundle) => (
                    <PremiumBundleCard
                      key={`bundle-card-${bundle.id}`}
                      currency={currency}
                      bundle={bundle}
                    />
                  ))}
            </Box>
          </Box>
          {/* premium products */}

          <Text.Normal
            weight="semibold"
            size="300"
            color="grey1000"
            title={i18n.t('ats.job_details.premium_portals.products.title')}
          >
            {i18n.t('ats.job_details.premium_portals.products.title')}
          </Text.Normal>
        </Box>
      </Box>
    </JobPostingLayout>
  )
}
